export default __webpack_public_path__ + "static/media/project.58e638a7.svg";